var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"templates-language-control"},[_c('div',{staticClass:"templates-language-control__actions"},[(_vm.translation)?_c('TemplatesTemplateStatus',{attrs:{"status":_vm.translation.status}},[_c('AppRouterLink',{staticClass:"templates-language-control__link",attrs:{"exact":"","title":"Ir al detalle de esta plantilla","to":{
          name: 'template-details',
          params: {
            temp_id: _vm.translation.id,
            temp_title: _vm.translationSlug,
          },
        }}},[_vm._v("\n        Ver\n      ")])],1):[(!_vm.isEditor)?_c('AppIcon',{attrs:{"icon":"far fa-times","title":"Sin traducción"}}):_c('AppIcon',{staticClass:"templates-language-control__add",attrs:{"icon":"far fa-plus","title":"Añadir traducción"},on:{"click":_vm.addTranslation}})]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }